module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("PhoneNumbers", "Edit phone number") ))==null?'':__t)+
'</legend><div><div class="half clearfix"><label for="phone-number-description-input">'+
((__t=( i18n.tc("PhoneNumbers", "Description:") ))==null?'':__t)+
'</label> <input type="text" id="phone-number-description-input" data-input="phone-number-description" placeholder="'+
((__t=( i18n.tc("PhoneNumbers", "Home, Work, Mobile ...") ))==null?'':__t)+
'" value="'+
((__t=( description ))==null?'':__t)+
'" required></div><div><label for="phone-number-number-input">'+
((__t=( i18n.tc("PhoneNumbers", "Number:") ))==null?'':__t)+
'</label> <input type="tel" id="phone-number-number-input" data-input="phone-number-number" value=""></div></div></fieldset><fieldset class="button-wrap"><button data-click="phone-number-cancel">'+
((__t=( i18n.tc("PhoneNumbers", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="phone-number-submit" disabled="disabled">'+
((__t=( i18n.tc("PhoneNumbers", "Save") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
